/**
 * Utility function to get and parse refresh interval from localStorage
 * @param {number} defaultValue - Default refresh interval in seconds if none found
 * @returns {number} Parsed refresh interval in seconds
 */
export const getRefreshInterval = (defaultValue = 300) => {
  // Default 300 seconds (5 minutes)
  const stored = localStorage.getItem("refresh_interval");
  if (!stored) return defaultValue;

  const parsed = parseInt(stored, 10);
  return isNaN(parsed) ? defaultValue : parsed;
};
